<template>
    <div>
        <div class="col backgroundForm">
            <div class="col col-md-10 offset-md-1">
                <div class="col col-md-6 offset-md-3">
                    <div class="alert alert-info" role="alert">
                        <h4 class="alert-heading" align="center">REPORTE</h4>
                    </div>
                </div>
            </div>
        </div>
        <embed :src="urlNew" type="application/pdf" width="100%" height="650px" @load="mLoading" />
    
        <modal-loading :id-modal="id_modal_progress" :title="title_modal" :status-send="send_dispatch" ></modal-loading>
    </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue'

import modalLoading from '../modal/modalLoading';

export default {
    name:'report',
    mounted(){
        this.mCallUrl();
    },
    data(){
        return{
            url_serve:null,
            charge:false,
            id_modal_progress:'id_report',
            title_modal:'Solicitando',
            send_dispatch:true
        }        
    },
    methods:{
        mCallUrl(){
            // console.log(this.$route.params.tpdf);
            this.activeModal(this.id_modal_progress);
            
            // este es con la conexion al sistema en produccion
            this.url_serve=axios.defaults.baseURL+'/';

            // this.url_serve=axios.defaults.baseURL;
            // this.url_serve='https://capitanias.armada.mil.bo/api_dgcp/public/index.php/api/';
            // console.log(this.url_serve)
            // axios.get('https://186.121.203.254/api_dgcp/public/index.php/api/connect').then((data)=>{
            //     if(data.data.estado){
            //      this.url_serve='https://186.121.203.254/api_dgcp/public/index.php/api/'
            //     }else{
            //         this.url_serve='https://192.168.1.8/api_dgcp/public/index.php/api/'
            //     }
                
            // }).catch(err=>{
            //     console.log(err)
            //     this.url_serve='https://192.168.1.8/api_dgcp/public/index.php/api/'
            // });
            
        },
        mLoading(){
            this.charge=true;
            setTimeout(()=>{
                this.inactiveModal(this.id_modal_progress);
            },2000)
        },
        activeModal(e){
            $(`#${e}`).modal('show');
        },
        inactiveModal(e){
            $(`#${e}`).modal('hide');
        }
    },
    computed:{
        urlNew(){
            // console.log(atob(this.$route.params.tpdf))
            let dc=atob(this.$route.params.tpdf);
            console.log(`${this.url_serve}${dc}?api_token=${Vue.auth.getToken()}#toolbar=1&navpanes=0&scrollbar=0`);
            return `${this.url_serve}${dc}?api_token=${Vue.auth.getToken()}#toolbar=1&navpanes=0&scrollbar=0`;
        }
    },
    components:{
        'modal-loading':modalLoading
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/report/report.vue